import { render, staticRenderFns } from "./RirekishoShogaiPreview.vue?vue&type=template&id=aa41e772"
import script from "./RirekishoShogaiPreview.vue?vue&type=script&lang=js"
export * from "./RirekishoShogaiPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports